'use strict';

angular.module('licensure.services')
    .factory('FBFormPositionPermissions', ['$http', '$q', function ($http, $q) {
        var get = function (id) {
            var d = $q.defer();

            $http.get(apiLocation + '/api/fbformpositionpermissions', {
                params: {
                    formID: id
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    console.log(response.data);
                    // handle error
                });

            return d.promise;
        }

        var save = function (formID, permission) {
            var d = $q.defer();

            var method = 'POST';
            var url = apiLocation + '/api/fbformpositionpermissions/';
            if (!isUndefined(permission.id)) {
                method = 'PUT';
                url += permission.id;
            }

            $http({
                method: method,
                url: url,
                data: {
                    formID: formID,
                    form_position_permission: permission
                }
            })
                .then(function (response) {
                    d.resolve(response.data);
                })
                .catch(function (response) {
                    // handle error
                });

            return d.promise;
        }

        return {
            get: get,

            getByCode: function (code) {
                var d = $q.defer();
                
                get(code).then(function (types) {
                    if (types.length > 0) {
                        d.resolve(types[0]);
                    }
                    else {
                        d.resolve(null);
                    }
                })

                return d.promise;
            },

            save: save
        }
    }])
;